<template>
  <v-app-bar id="core-app-bar" app dense flat fixed color="transparent">
    <!-- color="transparent" app dark -->
    <AboutDialog ref="helpDialog"></AboutDialog>
    <RequestAppDialog ref="requestAppDialog"></RequestAppDialog>

    <v-toolbar-title class="tertiary--text font-weight-light align-self-center" v-if="!exclusive">
      <v-fade-transition mode="out-in">
        <v-btn v-if="responsive" icon @click.stop="onClick">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-fade-transition>

      <!-- {{ title }} -->
    </v-toolbar-title>

    {{ mode }}

    <v-spacer />

    <div v-if="development">
      <a href="https://demos.creative-tim.com/vuetify-material-dashboard" target="_blank">original template</a>
      &nbsp;
      <a href="https://demos.creative-tim.com/vuetify-material-dashboard/#/components/icons" target="_blank">icons</a>
    </div>


    <v-toolbar-items>
      <v-row align="center" class="mx-0">
        <!-- <v-text-field class="mr-4 purple-input" color="purple" label="Search..." hide-details /> -->

        <!-- <v-btn icon to="/">
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </v-btn>-->

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn text v-ripple @click="displayRequestApp" v-on="on">
              Want an app?
            </v-btn>
          </template>
          <span>Learn about how you can request for an app!</span>
        </v-tooltip>

        <v-divider vertical inset></v-divider>

        <v-tooltip bottom v-if="!exclusive_termbank">
          <template v-slot:activator="{ on }">
            <router-link class="toolbar-items" to="/" v-on="on">
              <v-btn icon v-ripple>
                <v-icon color>mdi-home</v-icon>
              </v-btn>
            </router-link>
          </template>
          <span>Home</span>
        </v-tooltip>

        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-ripple
              href="https://www.assistedcoding.eu/contact"
              v-on="on"
            >
              <v-icon color>mdi-email</v-icon>
            </v-btn>
          </template>
          <span>Contact</span>
        </v-tooltip> -->

        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-ripple @click="displayHelp" v-on="on">
              <v-icon color>mdi-help</v-icon>
            </v-btn>
          </template>
          <span>About</span>
        </v-tooltip> -->

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-ripple v-on="on" @click.stop="openOptions">
              <v-icon color>mdi-settings</v-icon>
            </v-btn>
          </template>
          <span>Open settings</span>
        </v-tooltip>

        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-ripple href="https://www.assistedcoding.eu" v-on="on">
              <v-icon color>mdi-power</v-icon>
            </v-btn>
          </template>
          <span>Close and return to official site</span>
        </v-tooltip> -->

        <!-- <v-menu bottom left offset-y transition="slide-y-transition">
          <template v-slot:activator="{ attrs, on }">
            <v-btn class="toolbar-items" icon to="/notifications" v-bind="attrs" v-on="on">
              <v-badge color="error" overlap>
                <template slot="badge">{{ notifications.length }}</template>
                <v-icon color="tertiary">mdi-bell</v-icon>
              </v-badge>
            </v-btn>
          </template>

          <v-card>
            <v-list dense>
              <v-list-item
                v-for="notification in notifications"
                :key="notification"
                @click="onClick"
              >
                <v-list-item-title v-text="notification" />
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-btn to="/user-profile" icon>
          <v-icon color="tertiary">mdi-account</v-icon>
        </v-btn>-->
      </v-row>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import AboutDialog from "@/components/dialog/AboutDialog";
import RequestAppDialog from "@/components/dialog/RequestAppDialog";
import { DevelopmentModeDetector } from "@/components/mixins/DevelopmentModeDetector";

import { mapMutations } from "vuex";

export default {
  mixins: [DevelopmentModeDetector],
  components: {
    AboutDialog,
    RequestAppDialog
  },
  props: {
    exclusive: Boolean
  },
  data: () => ({
    notifications: ["Mike, John responded to your email", "You have 5 new tasks", "You're now a friend with Andrew", "Another Notification", "Another One"],
    title: null,
    responsive: false
  }),
  watch: {
    $route(val) {
      this.title = val.meta.name;
    }
  },
  computed: {
    mode() {
      if (process.env.NODE_ENV == "production") {
        return "";
      } else {
        return "Mode: " + process.env.NODE_ENV + ", API: " + process.env.VUE_APP_ROOT_API;
      }
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer", "setSecondaryDrawer", "toggleSecondaryDrawer"]),
    onClick() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    displayHelp() {
      this.$refs.helpDialog.open().catch({});
    },
    displayRequestApp() {
      this.$refs.requestAppDialog.open().catch({});
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991 || !this.$store.state.app.drawer) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    openOptions() {
      this.setSecondaryDrawer(!this.$store.state.app.secondaryDrawer);
    }
  }
};
</script>

<style>
/* Fix coming in v2.0.8 */
#core-app-bar {
  width: auto;
}

#core-app-bar a {
  text-decoration: none;
}
</style>
